import { inject } from '@angular/core'
import { BrandService } from './brand.service'

/**
 * FR-050 U6 (AC-9.2) — resolve + apply the brand before the first render.
 * Registered via `provideAppInitializer` AFTER the support-credential seed, so
 * a support window's first `/me` already carries the support header.
 *
 * FR-051 U7 — also AFTER `initHostContext` (host-context.service.ts): the brand
 * on an agency host comes from the host, so `bootstrap()` awaits the host
 * context that initializer already started.
 */
export function initBrand(): Promise<void> {
  return inject(BrandService).bootstrap()
}
